import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';
import { getLeaseTermUnitsLabel } from 'bundles/apex/deals/helpers/labels';

export function LeaseTermValue({ deal }) {
  let value;
  if (deal.leaseTerm) {
    value = `${deal.leaseTerm} ${getLeaseTermUnitsLabel(deal.leaseTermUnits)}`;
  }

  return <Value name="leaseTerm" value={value} />;
}

LeaseTermValue.propTypes = {
  deal: PropTypes.shape({
    leaseTerm: PropTypes.number,
    leaseTermUnits: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(LeaseTermValue);
